import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom'
import commonNetwork from "../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { useDispatch, } from "react-redux";
import { getErpParameters } from "../../store/slices/erpParameterSlice";
import { postMessageTypes } from "../../constants/postMessageFileds";
import InstallmentCard from "../components/PosDetail/InstallmentCard";
import VpInformations from "../components/PosDetail/VpInformations";
import { Box, Tab, Tabs } from "@mui/material";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { postWebViewMessage } from "../../common/helpers/messageHelper";
import useAdminCheck from "../../hooks/useAdminCheck";
import { getNavigationUrl } from "../../common/helpers/navigationHelpers";

const initialOptions = [{
  value: 0,
  label: ""
}];

export default function PosDetail() {
  useAdminCheck();
  let { bankId } = useParams();
  const { firmname } = useParams();
  const location = useLocation()
  const { vpId, isPf } = location.state || { vpId: 0, isPf: false };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const installmentCardRef = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [vpInfo, setVpInfo] = useState({
    bankId: Number(bankId),
    bankName: "",
    modalId: 0,
    modalName: "",
    vpDisplayName: "",
    istest: false,
    status: true,
    isDefault: false,
    isManufacturer: false,
    isinstallment: false,
    extraParams: false,
    merchantId: "",
    terminalId: "",
    username: "",
    password: "",
    storeKey: "",
    erpBankCode: "",
    erpContractCode: "",
    extraParam1: null,
    extraParam2: null,
    extraParam3: null,
    extraParam4: null,
    extraParam5: null,
    extraParam6: null,
    extraParam7: null,
    extraParam8: null,
    extraParam9: null,
    bankPageUrl: "",
    isCheckCommission: false,
  });
  const [bankFields, setBankFields] = useState({});
  const [isVpErrorStatus, setIsVpErrorStatus] = useState(false);
  const [isVpErrorMessage, setIsVpErrorMessage] = useState(false);
  const [isDefaultVp, setIsDefaultVp] = useState(true);
  const [isCurrentVp, setIsCurrentVp] = useState(false);
  const [isVpSaved, setIsVpSaved] = useState(vpId > 0);
  const [tabIndex, setTabIndex] = useState('1');
  const [isInstallmentLoading, setIsInstallmentLoading] = useState(false);
  const [allBrandWithInstallment, setAllBrandWithInstallment] = useState([]);
  const [selectedCardBrand, setSelectedCardBrand] = useState(null);
  const [posDetailVpId, setPosDetailVpId] = useState(vpId);
  const [posDetailVpName, setPosDetailVpName] = useState("");
  const [isInstallmentApplyToAll, setIsInstallmentApplyToAll] = useState(false);
  const [erpcontractcodeOptions, setErpcontractcodeOptions] = useState(initialOptions);


  useEffect(() => {
    selectErpContractList();
    dispatch(getErpParameters());
    getErpValues();
  }, []);

  useEffect(() => {
    // setBankFields(bankFieldsTemp);
    selectBankFieldFromApi();
    // setVpInfo(
    //   Object.assign(vpInfo, {
    //     bankId: Number(bankId),
    //     modalId: bankFieldsTemp.modalId,
    //     bankName: bankFieldsTemp.bankName,
    //     modalName: bankFieldsTemp.modalName,
    //   })
    // );
    if (vpId) {
      // setIsLoading(true);
      getVpInformationById(vpId);

      selectInstallmentList();
    }
    getDefaultVp();


  }, []);

  useEffect(() => {
    if (location.state == null) {
      toast.error("Firmanın böyle bir pos tanımı bulunmamaktadır.");
      getNavigationUrl("/pos-baglanti-ayarlari");
    }
  }, [location]);

  const selectBankFieldFromApi = async () => {

    const params = {
      bankId: bankId
    }
    const result = await commonNetwork.get("/bank/get-bank-parameters-from-bank", params);

    if (result.isSuccess && result.data) {
      setBankFields(result.data);
      const resultData = result.data;

      setVpInfo(
        Object.assign(vpInfo, {
          bankId: Number(bankId),
          modalId: resultData.modalId,
          bankName: resultData.bankName,
          modalName: resultData.modalName,
          bankPageUrl: resultData.bankPageUrl,
          isCheckCommission: resultData.isCheckCommission,
        })
      );
    } else {
      navigate(getNavigationUrl("/pos-baglanti-ayarlari"));
    }
    if (!vpId) {
      setIsLoading(false);
    }

  }

  const getVpInformationById = async (id) => {
    var vpId = id;

    var url = '/virtualpos/' + vpId
    const res = await commonNetwork.get(url);
    if (res.isSuccess) {
      res.data.isMinAmount = res.data.minAmount > 0 ? true : false;

      const sanitizedData = {
        ...res.data,
        erpBankCode: res.data.erpBankCode ?? "",
        terminalId: res.data.terminalId ?? ""
      };
      setVpInfo((prev) => ({
        ...prev,
        ...sanitizedData,
      }));

      setPosDetailVpName((res.data.vpDisplayName || vpInfo.bankName));
      setIsLoading(false);
      setIsInstallmentApplyToAll(res.data.isInstallmentApplyAll || false);

    }
    else {
      setIsVpErrorStatus(true);
      setIsVpErrorMessage(res.errorMessage);
      setIsLoading(false);
    }
  }
  const getDefaultVp = async () => {
    var url = '/virtualpos/GetDefaultVp/' + vpId
    const res = await commonNetwork.get(url);
    if (res.isSuccess) {
      setIsDefaultVp(res.data.isDefaultVp);
      setIsCurrentVp(res.data.isCurrentVp);
    } else {
      setIsDefaultVp(false);
      setIsCurrentVp(false);
    }
  }

  const selectErpContractList = () => {

    var messageBody = { requestType: postMessageTypes.selectContractList, requestBody: "" };
    postWebViewMessage(JSON.stringify(messageBody));
  }

  const selectInstallmentList = async () => {
    setIsInstallmentLoading(true);
    const params = {
      vpId: vpId || 0,
      bankId: bankId
    }
    const result = await commonNetwork.get("/installment/all-by-vp", params);

    setIsInstallmentLoading(false);


    if (result.isSuccess) {
      setAllBrandWithInstallment(result.data || []);
      if (result.data && result.data.length > 0) {
        setSelectedCardBrand(result.data[0].bankBrand);
      }
    } else {

    }
  }

  const switchInstallmentTab = (insertedVp, insertedVpName) => {
    setPosDetailVpId(insertedVp);
    setPosDetailVpId(insertedVp);
    selectInstallmentList();
    setTabIndex("2");
  }


  const handleTabChange = (event, newValue) => {
    if (newValue == "2" && !isVpSaved) {
      toast.error("Taksit tanımı için önce Pos tanımını tamamlayınız");
    } else {
      setTabIndex(newValue);
    }

  };

  const getErpValues = async () => {
    const result = await commonNetwork.get('/integration/get-erp-values');

    try {
        if (result.isSuccess) {
            const erpcontractcodeData = result.data.erpContractCodes.map((item) => ({
                value: item.value,
                label: item.label
            }));

            setErpcontractcodeOptions(erpcontractcodeData);
        } else {
            toast.error(result.errorMessage);
        }
    } catch (error) {

    }
}

  return (
    <div className="w-full flex flex-col">
      <div className="px-4 pt-4 flex flex-col justify-start space-y-2">
        <div className="flex flex-row items-center">
          <img src={"/icons/link-dark.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            Pos Entegrasyonları
          </span>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center">

        <Box sx={{ width: '100%', typography: 'body1' }} className="px-4 pb-4">
          <TabContext value={tabIndex}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange} aria-label="">
                <Tab label="POS TANIMLARI" value="1" />
                <Tab label="TAKSİT TANIMLARI" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" className="!p-0 !rounded-md">
              <VpInformations bankFields={bankFields} isCurrentVp={isCurrentVp} isDefaultVp={isDefaultVp}
                isLoading={isLoading} isVpErrorMessage={isVpErrorMessage} isVpErrorStatus={isVpErrorStatus}
                setIsLoading={setIsLoading} setVpInfo={setVpInfo} vpInfo={vpInfo}
                setIsVpSaved={setIsVpSaved} switchInstallmentTab={switchInstallmentTab} erpcontractcodeOptions={erpcontractcodeOptions}
              ></VpInformations>
            </TabPanel>
            <TabPanel value="2" className="!p-0 !rounded-md">
              <InstallmentCard vpId={posDetailVpId} ref={installmentCardRef} bankId={bankId}
                isinstallment={true} isPf={isPf}
                allBrandWithInstallment={allBrandWithInstallment}
                isInstallmentLoading={isInstallmentLoading} selectedCardBrand={selectedCardBrand}
                setAllBrandWithInstallment={setAllBrandWithInstallment}
                setSelectedCardBrand={setSelectedCardBrand}
                isInstallmentApplyToAll={isInstallmentApplyToAll}
                setIsInstallmentApplyToAll={setIsInstallmentApplyToAll}
                posDetailVpName={posDetailVpName}
                isCheckCommission={vpInfo.isCheckCommission}
                isPosActive={vpInfo.status}
              />
            </TabPanel>
          </TabContext>
        </Box>
      </div>
    </div>

  );

}
